import React from 'react';

import { mode_badge } from './logic';
import './email_send.css';

// Where a manual send goes right now. mode: 'TEST' | 'LIVE' | null (not read yet: nothing shown).
const ModeBadge = ({ mode }) => {
  if (!mode) return null;
  const b = mode_badge(mode);
  return (
    <span className={`tp-es-badge tp-es-badge-${b.mode.toLowerCase()}`} role="status">
      {b.text}
    </span>
  );
};

export default ModeBadge;
